/*
  elestablo 2026 · Evento de clic a WhatsApp para los píxeles de Shopify (Web Pixels API).
  Escucha los clics en cualquier enlace a wa.me o api.whatsapp.com y publica el evento personalizado
  'elestablo:whatsapp_click' con Shopify.analytics.publish(). Un píxel personalizado
  (Configuración › Eventos de clientes) lo recibe con analytics.subscribe('elestablo:whatsapp_click', …)
  y lo manda a GA4 y a Meta. El código de ese píxel está en seo-medicion/PIXEL-WHATSAPP.md.

  Datos del evento (event.customData en el píxel):
    ubicacion: data-ee-wa="…" del enlace; si no tiene, la sección más cercana ("seccion-<id>").
    pagina:    ruta de la página (con ?view= en las páginas de servicio).
    producto:  título del producto en la ficha (data-ee-producto de esta etiqueta <script>).
    detalle:   data-ee-wa-detalle del enlace, si existe (chip o servicio).
  No cambia nada visible ni detiene el enlace: si Shopify.analytics no existe, no hace nada.
*/
(function () {
  var EVENTO = 'elestablo:whatsapp_click';
  var WHATSAPP = /^https?:\/\/(wa\.me|api\.whatsapp\.com|(www\.)?whatsapp\.com\/send)/i;
  var yo = document.currentScript;
  var producto = (yo && yo.getAttribute('data-ee-producto')) || '';

  function pagina() {
    var ruta = window.location.pathname;
    var vista = null;
    try {
      vista = new URLSearchParams(window.location.search).get('view');
    } catch (e) {}
    return vista ? ruta + '?view=' + vista : ruta;
  }

  function ubicacion(enlace) {
    var propia = enlace.getAttribute('data-ee-wa');
    if (propia) return propia;
    var seccion = enlace.closest('[id^="shopify-section-"]');
    if (seccion) {
      var id = seccion.id.replace('shopify-section-', '');
      var corte = id.lastIndexOf('__');
      return 'seccion-' + (corte >= 0 ? id.slice(corte + 2) : id);
    }
    return 'otro';
  }

  function alClic(evento) {
    if (evento.type === 'auxclick' && evento.button !== 1) return;
    var enlace = evento.target && evento.target.closest ? evento.target.closest('a[href]') : null;
    if (!enlace || !WHATSAPP.test(enlace.href)) return;
    var datos = { ubicacion: ubicacion(enlace), pagina: pagina() };
    if (producto) datos.producto = producto;
    var detalle = enlace.getAttribute('data-ee-wa-detalle');
    if (detalle) datos.detalle = detalle;
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(EVENTO, datos);
      }
    } catch (e) {}
  }

  document.addEventListener('click', alClic, true);
  document.addEventListener('auxclick', alClic, true);
})();
